
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return require("private-next-pages/blog/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog"])
      });
    }
  